import React from 'react';

const Header = () => {
  return (
    <header>
      <div id='social-media'>
        <a
          href='https://twitter.com/aishatech0926'
          target='_blank'
          rel='noreferrer'
        >
          <i className='fa-brands fa-twitter'></i>
        </a>

        <a
          href='https://www.instagram.com/ai.kat.0926/'
          target='_blank'
          rel='noreferrer'
        >
          <i className='fa-brands fa-instagram'></i>
        </a>

        <a
          href='https://www.linkedin.com/in/sittie-aisha-a-307119163/'
          target='_blank'
          rel='noreferrer'
        >
          <i className='fa-brands fa-linkedin'></i>
        </a>

        <a href='https://dev.to/aisha0926' target='_blank' rel='noreferrer'>
          <i className='fa-brands fa-dev'></i>
        </a>

        <a href='https://github.com/aisha0926' target='_blank' rel='noreferrer'>
          <i className='fa-brands fa-github'></i>
        </a>
      </div>
    </header>
  );
};

export default Header;
